import { createRoot } from "react-dom/client";
import "./index.css";
import Root from "./Root.tsx";

// import LogRocket from "logrocket";
// if (import.meta.env.MODE === "production") {
//   LogRocket.init("jlo86g/cadendar");
// }

const container = document.getElementById("renderRoot");
const root = createRoot(container!);
root.render(<Root />);
